import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Button } from "@h3/antd-vue";
import { updateTheme, colorsMap } from '../../tools/settingConfig';
import { themesApi } from "@cloudpivot/api";
let themeSetting = class themeSetting extends Vue {
    constructor() {
        super(...arguments);
        this.outwardType = 'light'; // 默认外观
        this.showViewBox = false;
        this.currentColorName = 'default';
    }
    // 延迟触发预览窗口显示。用于添加动画
    onOpenSettintThemeChange(val) {
        if (val) {
            setTimeout(() => this.showViewBox = true, 600);
        }
        else {
            this.showViewBox = false;
        }
    }
    get currentColor() {
        return this.currentItem.primaryColor;
    }
    get currentItem() {
        return this.colors.find(el => el.name === this.currentColorName);
    }
    close() {
        this.$emit('close');
    }
    changeColor(item) {
        if (item.name === 'default') {
            this.outwardType = 'light';
        }
        this.currentColorName = item.name;
    }
    // 去后台设置
    goToset() {
        window.open('/admin/#/system/license?tabKey=2');
    }
    // 修改主题
    editTheme() {
        const params = {
            color: this.currentColorName,
            outward: this.outwardType
        };
        return themesApi.editTheme(params);
    }
    // 还原主题
    reset() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentColorName = 'default';
            this.outwardType = 'light';
            const res = yield this.editTheme();
            if (res.errcode === 0) {
                this.$message.success(res.errmsg);
                updateTheme({
                    color: this.currentColorName,
                    outwardType: 'light',
                    store: this.$store
                });
                this.close();
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    // 更新主题
    updataThemes() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield this.editTheme();
            if (res.errcode === 0) {
                this.$message.success(res.errmsg);
                updateTheme({
                    color: this.currentColorName,
                    outwardType: this.outwardType,
                    store: this.$store
                });
                this.close();
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    // 回显主题配置
    mounted() {
        const item = colorsMap.find(el => el.name === this.$store.state.themeColor);
        this.currentColorName = this.colors.find(el => el.primaryColor === item.primaryColor).name;
        this.outwardType = this.$store.state.outwardType;
    }
    get colors() {
        return colorsMap;
    }
    get itemStyle() {
        return {
            'background-color': this.outwardType === 'light' ? this.currentColor : '#fff'
        };
    }
    get activeStyle() {
        return {
            'border-bottom': this.outwardType === 'light' ? `2px solid ${this.currentColor}` : 'none'
        };
    }
    get headerStyle() {
        return {
            'background-color': this.outwardType === 'dark' ? this.currentColor : '#ffffff'
        };
    }
    get leftStyle() {
        return {
            'background-color': this.outwardType === 'dark' ? colorsMap.find((el) => this.currentColor === el.primaryColor).dark_subColor : '#ffffff'
        };
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], themeSetting.prototype, "openSettintTheme", void 0);
tslib_1.__decorate([
    Watch('openSettintTheme', { immediate: true })
], themeSetting.prototype, "onOpenSettintThemeChange", null);
themeSetting = tslib_1.__decorate([
    Component({
        name: "themeSetting",
        components: {
            AButton: Button
        },
    })
], themeSetting);
export default themeSetting;
